/* globals JSON, window, document */
/* exported JSON, window, document */
require('lib/util/helpers');


(function ($, SCS) {
	'use strict';

	/**
	 * Global utilities for all Swisscom projects
	 *
	 * @author Thomas Junghans
	 * @namespace SCS
	 * @class utils
	 */
	SCS.utils = SCS.utils || {};

	var zeroFill = require('lib/util/helpers').zeroFill;

	/**
	 * Override jQuery.fn.load to call SCS.utils.initNewModules on updated elements.
	 */
	var oldLoad = $.fn.load;
	$.fn.load = function (url, data, callback) {
		var element = this;
		callback = callback || data;
		if (!$.isFunction(callback)) {
			callback = $.noop;
		} else if ($.isFunction(data)) {
			data = null;
		}
		return oldLoad.call(element, url, data, function () {
			SCS.utils.initNewModules(element);
			callback.apply(this, arguments);
		});
	};

	/**
	 * Returns LESS variables that were previously stored in the "font-family" property of a hidden element
	 *
	 * You have to define the values in LESS like this:
	 *	// bring less variables to javascript
	 *	myElement > .less-vars {
	 *		// local variables to prevent calculation in the JSON object
	 *		@smallLogoSize: @logoSpace - @logoSmallDifference;
	 *
	 *		// generate JSON out of a object via LESS-Javascript
	 *		font-family: ~`"'" +
	 *			JSON.stringify({
	 *				mobile: {
	 *					breakpoint: '@{ResponsiveMaxMobile}'.replace('px', '')
	 *				},
	 *				desktop: {
	 *					logoTotalWidth: {
	 *						big: '@{logoSpace}'.replace('px', ''),
	 *						small: '@{smallLogoSize}'.replace('px', '')
	 *					}
	 *				}
	 *			})
	 *			+ "'"
	 *		` !important;
	 *
	 *		display: none;
	 *	}
	 *
	 * @method getLessVars
	 * @param {HTMLElement|jQuery} element - must either be the element (with less vars) itself or must contain a child element with class "less-vars"
	 * @returns Object|String
	 */
	SCS.utils.getLessVars = function (element) {
		var $el = $(element),
			$lessVars = $el.is('.less-vars') ? $el : $el.children('.less-vars'),
			fontFamily = $lessVars.css('font-family') || '',
			contentValue = fontFamily.replace(/\\"/g, '"').replace(/(^")|("$)|(^')|('$)/g, '');

		try {
			return JSON.parse(contentValue);
		} catch (e) {
			return contentValue;
		}
	};

	/**
	 * Remove CSS classes that match a substring.
	 *
	 * If cssClassAttriube = "cssClassFoo cssClassBar cssClassBaz cssClassBarBaz" and
	 * cssClassesToRemove = "Bar" then the return value will be "cssClassFoo cssClassBaz"
	 *
	 * @param cssClassAttribute {string}
	 * @param cssClassesToRemove {string}
	 * @returns {string}
	 */
	SCS.utils.removeCssClasses = function (cssClassAttribute, cssClassesToRemove) {
		var classes = cssClassAttribute.split(/\s+/);

		for (var i = 0; i < classes.length;) {

			if (classes[i].indexOf(cssClassesToRemove) > -1) {
				classes.splice(i, 1);
			} else {
				i += 1;
			}
		}
		return classes.join(' ');
	};

	/**
	 * Expects the value of a css class attribute and the prefix of a css class eg. scs-. An array with all prefixed
	 * css classes is returned
	 *
	 * @method getClassNamesWithPrefix
	 * @param {string} classAttribute
	 * @param {string} prefix
	 * @returns {Array<string>}
	 */
	SCS.utils.getClassNamesWithPrefix = function (classAttribute, prefix) {
		var cssClasses = classAttribute.split(/\s+/),
			customClasses = [],
			i = 0,
			ii = cssClasses.length;

		if (typeof(prefix) === 'string') {
			for (; i < ii; i += 1) {
				if (cssClasses[i].indexOf(prefix) >= 0) {
					customClasses.push(cssClasses[i]);
				}
			}
		} else {
			customClasses = cssClasses;
		}

		return customClasses;
	};

	/**
	 * Checks if the path suffix is either jpeg, jpg, png or gif
	 *
	 * @method isImagePath
	 * @namespace SCS.utils
	 * @param path
	 * @returns {boolean} true on success
	 */
	SCS.utils.isImagePath = require('lib/util/url').isImagePath;

	SCS.utils.isMobilePage = require('lib/util/helpers').isMobilePage;

	/**
	 * Returns true if obj is string and not ''.
	 *
	 * @method isNonEmptyString
	 * @param obj
	 * @returns {boolean}
	 */
	SCS.utils.isNonEmptyString = function (obj) {
		return this.isString(obj) && obj.length > 0;
	};

	SCS.utils.isString = function (obj) {
		return typeof obj === 'string' || (obj !== null && typeof obj === 'object' && obj.constructor === String);
	};

	/**
	 * @method parseNumber
	 * @namespace SCS.utils
	 * @param numericValue
	 * @return {Number}
	 */
	SCS.utils.parseNumber = function (numericValue) {
		if (!numericValue) {
			return 0;
		}
		var result = Number($.trim(numericValue.toString()));
		return isNaN(result) ? 0 : result;
	};

	/**
	 * Short cut for getElementId including the conversion into a jQuery object. It is faster than $('#' + id).
	 * @method $id
	 * @param id {string}
	 * @returns {jQuery}
	 */
	SCS.utils.$id = function (id) {
		return $(document.getElementById(id));
	};

	/**
	 * Returns a unique id for the given DOM element. This id does not change if it is set once.
	 * @method getUniqueIdOfElement
	 * @param {HTMLElement|jQuery} element
	 * @returns {String}
	 */
	SCS.utils.getUniqueIdOfElement = require('lib/util/helpers').getUniqueIdOfElement;

	/**
	 * Checks if a url is external - can be used to check if a url can be loaded via ajax (same domain policy)
	 * @method isExternalUrl
	 * @param url {string}
	 * @returns boolean
	 */
	SCS.utils.isExternalUrl = require('lib/util/url').isExternalUrl;

	SCS.utils.isIE11 = require('lib/util/browserDetect').isIE11;

	/**
	 * Converts kbit/s, MBit/s and GBit/s to bits per second (integer)
	 * @method convertToBits
	 * @param {String} s For example '15 MBit/s'
	 * @returns {Integer} Bits per second.
	 */
	SCS.utils.convertToBits = function (s) {
		var i = parseInt(s, 10);
		// kilobit per second (symbol kbit/s or kb/s, often abbreviated "kbps")
		if (s.match(/[kK][bB](it)?[\/p]s/)) {
			return i * 1000;
		}
		// megabit per second (symbol Mbit/s or Mb/s, often abbreviated "Mbps")
		if (s.match(/M[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000;
		}
		// gigabit per second (symbol Gbit/s or Gb/s, often abbreviated "Gbps")
		if (s.match(/G[bB](it)?[\/p]s/)) {
			return i * 1000 * 1000 * 1000;
		}
		return i;
	};

	/**
	 * Formats a given price to a "0.00" format
	 * @method formatPrice
	 * @param {number} price
	 * @returns {string}
	 */
	SCS.utils.formatPrice = function (price) {
		var cents = Math.round(price * 100 || 0) + '';
		while (cents.length < 3) {
			cents = '0' + cents;
		}
		return cents.substr(0, cents.length - 2) + '.' + cents.substr(-2, 2);
	};

	/**
	 * Formats a price/number of format "12.00" or "12" to "12.–", and "12.50" to "12.50"
	 * @param price {(number|string)}
	 * @returns {string}
	 */
	SCS.utils.formatPriceWithDash = function(price) {
		price = String(price);
		if (/[.][0-9]?[1-9]/.test(price)) {
			return SCS.utils.formatPrice(price);
		}
		return price.replace(/^(-?\d+)($|\.0*$|\.00.*$)/, '$1.–');
	};

	/**
	 * Formats time (hours) to "00:00" format
	 * @method formatTime
	 * @param {float} hours
	 * @param {string} delimiter
	 * @returns {string}
	 */
	SCS.utils.formatTime = function (hours, delimiter) {
		return zeroFill(Math.floor(hours), 2) +
			(delimiter ? delimiter : ':') +
			zeroFill(Math.floor((hours % 1) * 60), 2);
	};

	/**
	 * Returns a date object containing the actual server time.
	 * IMPORTANT:
	 * - at the moment this doesn not work until SC ads a "data-server-timestamp" attribute to its body
	 * - if your timezone is different to the servers the minutes can be inaccurate (max as many as the servers caching time - 3 mins at the time)
	 *
	 * @method getServerTime
	 * @returns {Date}
	 */
	SCS.utils.getServerTime = function () {
		var serverTimeStamp = $('body').data('server-timestamp'),
			serverTime,
			browserTime = new Date(),
			acceptableOffset = 1000 * 60 * 10; // 10 minutes

		// fix for swisscom IF there is an element on the page with attribute "data-now"
		if (!serverTimeStamp) {
			serverTimeStamp = $('[data-now]:first').data('now');
		}

		serverTime = new Date(Number(serverTimeStamp));

		/*
		 * The servers timestamp is "old" because of caching. This means we don't have an accurate time and events cannot be started at the exact time.
		 * Therefore if the offset between servertime and browsertime is lower than 10 minutes we assume that both have the same timezone.
		 * Then browsertime is taken. Otherwise the user has a different timezone and then servertime is taken with the above mentioned drawbacks.
		 * The caching time of the server is 3 minutes at the time (mrz. 2015)
		 */
		return (browserTime - serverTime <= acceptableOffset ? browserTime : serverTime);
	};


	SCS.utils.ajaxCache = {

		/**
		 * @private
		 */
		cachedPromises: {},

		/**
		 * Caches ajax calls
		 * @method ajax
		 * @param {object} settings - Settings object required by jQuery.ajax, containing at minimum the url
		 * @param {function} callback
		 * @returns {jQuery.promise}
		 */
		ajax: function (settings, callback) {
			if (!this.cachedPromises[settings.url]) {
				this.cachedPromises[settings.url] = $.Deferred(function (defer) {
					$.ajax(settings).then(defer.resolve, defer.reject);
				}).promise();
			}

			return this.cachedPromises[settings.url].done(callback);
		},

		/**
		 * Caches ajax JSON calls
		 * @method getJSON
		 * @param {string} url
		 * @param {function} callback
		 * @param {number} [timeout] - in milliseconds
		 * @returns {jQuery.promise}
		 */
		getJSON: function (url, callback, timeout) {
			return this.ajax({url: url, dataType: 'json', timeout: timeout}, callback);
		}

	};


	/**
	 * Converts a date string (with or without time) into a native date object
	 * @method fromString
	 * @param {string} dateString - For example '2014-12-31 12:15', '31.12.2014' or '1364560948000+0100'
	 * @returns {Date}
	 */
	function fromString(dateString) {
		var parts,
			date;

		if (!dateString || !dateString.match) {
			return null;
		}

		// dates in english format (2014-12-31 12:15:00) with or without time
		parts = dateString.match(/^(\d+)-(\d+)-(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[1], parts[2] - 1, parts[3], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in german format (31.12.2014 12:15:00) with or without time
		parts = dateString.match(/^(\d+)\.(\d+)\.(\d+)\s?(\d*):?(\d*):?(\d*)$/);
		if (parts) {
			return new Date(parts[3], parts[2] - 1, parts[1], parts[4] || '0', parts[5] || '0', parts[6] || '0');
		}

		// dates in eCommerce format (1364560948000+0100)
		parts = dateString.match(/^(\d+)\+\d+$/);
		if (parts) {
			return new Date(parseInt(parts[1], 10));
		}

		// no match found -> try converting it to an integer
		date = new Date(parseInt(dateString, 10));
		if (date && !isNaN(date.getTime())) {
			return date;
		}

		return null;
	}

	/**
	 * Converts a date object into a formatted date (and optional time) string
	 * @method format
	 *
	 * @param {Date} date
	 *
	 * @param {object} [options] - Configure the format
	 * @param {bool} [options.english=false] - Formats the date in english format if TRUE ('2014-12-31' instead of '31.12.2014')
	 * @param {bool} [options.utc=false] - Converts the date to UTC if true
	 * @param {bool} [options.shortYear=false] - Formats the year as two digit value if TRUE ('14' instead of '2014')
	 * @param {bool} [options.time=false] - Includes the time if TRUE - only date is included by default
	 * @param {bool} [options.seconds=false] - Includes the seconds time if TRUE and TIME option is set - only hours and minutes are included by default
	 *
	 * @returns {string} - For example '31.12.2014', '31.12.14' or '2014-12-31 15:13:00'
	 */
	function format(date, options) {
		if (!date || !date.getTime || isNaN(date.getTime())) {
			return null;
		}

		options = $.extend({
			english: false,
			utc: false,
			shortYear: false,
			time: false,
			seconds: false
		}, options);

		var day = zeroFill(options.utc ? date.getUTCDate() : date.getDate()),
			month = zeroFill((options.utc ? date.getUTCMonth() : date.getMonth()) + 1),
			year = (options.utc ? date.getUTCFullYear() : date.getFullYear()).toString().substr(options.shortYear ? 2 : 0),
			hours = zeroFill(options.utc ? date.getUTCHours() : date.getHours()),
			minutes = zeroFill(options.utc ? date.getUTCMinutes() : date.getMinutes()),
			seconds = zeroFill(options.utc ? date.getUTCSeconds() : date.getSeconds()),
			time = (options.time ? (' ' + hours + ':' + minutes + (options.seconds ? (':' + seconds) : '')) : '');

		return (options.english ? (year + '-' + month + '-' + day) : (day + '.' + month + '.' + year)) + time;
	}

	/**
	 * Resets the time of a given date to zero (eg. 31.12.2014 00:00:00)
	 * @method resetTime
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function resetTime(date) {
		var startOfDay = new Date(date);
		startOfDay.setHours(0);
		startOfDay.setMinutes(0);
		startOfDay.setSeconds(0);
		startOfDay.setMilliseconds(0);
		return startOfDay;
	}

	/**
	 * Resets the time of a given date to midnight (eg. 31.12.2014 23:59:59)
	 * @method endOfDay
	 * @param {Date} date
	 * @returns {Date} - new date instance (original date is left as it is - pass by value)
	 */
	function endOfDay(date) {
		var endOfDay = new Date(date);
		endOfDay.setHours(23);
		endOfDay.setMinutes(59);
		endOfDay.setSeconds(59);
		endOfDay.setMilliseconds(999);
		return endOfDay;
	}


	/**
	 * Render opening hours (blocks of work time)
	 *
	 * @method formatDailyHours
	 * @param {int} hours - the time in hours (9.5 => 9:30)
	 * @param {boolean} pad - should numbers be padded (unclear)
	 * @param {Object} locales - hash-map of localization labels
	 * @returns {String} ex. `09.00-11.30 Uhr & 13.00-16.30 Uhr`
	 */
	function formatDailyHours(hours, pad, locales) {
		var pairs = [];
		pad = pad ? 2 : 1;
		locales = locales || {};
		var timeDelim = locales.timeDelim;
		var hourDelim = locales.hourDelim;
		if (typeof timeDelim !== 'string') { timeDelim = '.'; }
		if (typeof hourDelim !== 'string') { hourDelim = ' & '; }
		if (!hours) { return locales.closed; }
		for (var i = 0; i < hours.length; i += 2) {
			var start = hours[i+0], end = hours[i+1];
			if (Math.abs(start - end) > 0) {
				var parts = [ SCS.utils.formatTime(start, timeDelim, pad) ];
				if (start !== end) { parts.push(SCS.utils.formatTime(end, timeDelim, pad)); }
				pairs.push(parts.join(locales.timeSeqDelim || '-') + ' ' + locales.clock);
			}
		}
		if (pairs.length) {
			return pairs.join(hourDelim);
		} else {
			return locales.closed;
		}
	}

	// upgrade alternative config to internaly used config
	// accepts one or multiple input arguments (varargs)
	function parseOpeningHours(openingHours) {

		var i;

		// assert for at least one argument
		if (!openingHours) { return false; }

		// return if input argument is already a valid constraints data object
		if (typeof openingHours === 'object' && openingHours.week) { return openingHours; }

		// create new config
		// closed all day long
		var config = {
			day: {}, // daily exceptions
			week: [
				true, // monday (true = inherit)
				true, // tuesday (true = inherit)
				true, // wednesday (true = inherit)
				true, // thursday (true = inherit)
				true, // friday (true = inherit)
				false,// saturday (false = closed)
				false // sunday (false = closed)
			],
			hours: false,
			time: true
		};

		var rules = [];
		// aggregate input from varargs
		for (i = 0; i < arguments.length; i += 1) {
			if (typeof arguments[i] === 'string') {
				rules.push(arguments[i]);
			} else if (arguments[i].length) {
				rules = rules.concat(arguments[i]);
			}
		}

		// weekdays are needed to create mapping from parsed to index
		var weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

		// parse all rules into constraints data
		for (i = 0; i < rules.length; i += 1) {
			// split rule into fragments (hope I got it right)
			var fragments = rules[i].split(/(?:\s*,\s*|\s+)/);
			// assert for minimal parsed fragments
			if (fragments.length < 3) { continue; }
			// get last two items for opening hours block
			var to = fragments.pop(), from = fragments.pop();
			for (var n = 0; n < fragments.length; n += 1) {
				// get fragment to check if it is a weekday
				var fragment = fragments[n].toLowerCase();
				var weekday = weekdays.indexOf(fragment);
				// found a rule that includes a date
				if (fragments[n].match(/^0*(\d+)\.0*(\d+)\.?$/)) {
					var sel = [RegExp.$1, RegExp.$2].join('.');
					config.day[sel] = updateOpeningHours(config.day[sel], toHours(from), toHours(to));
				}
				// found a rule for weekday
				else if (weekday !== -1) {
					config.week[weekday] = updateOpeningHours(config.week[weekday], toHours(from), toHours(to));
				}
			}
		}
		return config;
	}
	// EO parseOpeningHours

	// add opening hours properly to a week config, evne if there are already other opening hours definied previously
	function updateOpeningHours(config, from, to) {
		// when we need to update the values already in that config
		if(!config || !config.length) {
			return [from, to];
		} else {
			var addedToExisting = false;
			var niceConfig = [];
			for(var i = 0; i < config.length; i+=2) {
				niceConfig.push([config[i*2+0], config[i*2+1]]);
			}
			$.each(niceConfig, function(i, span) {
				// new span total before old or
				// new span is total after old
				if(to < span[0] || from > span[1]) {
					return;
				}
				if(from < span[0] && to > span[0] && to < span[1]) {
					// new span starts before and ends within
					niceConfig[i][0] = from;
				} else if(from > span[0] && from < span[1] && to > span[1]) {
					// new span starts within and ends after
					niceConfig[i][1] = to;
				} else if(from < span[0] && to > span[1]) {
					// new span widens the old on both sides
					niceConfig[i][0] = from;
					niceConfig[i][1] = to;
				}
				addedToExisting = true;
			});
			if(!addedToExisting) {
				// if its a span before
				if(to < config[0]) {
					niceConfig.unshift([from, to]);
				// if its a span after
				} else {
					niceConfig.push([from, to]);
				}
			}
			config = [];
			$.each(niceConfig, function(i, span) {
				config.push(span[0]);
				config.push(span[1]);
			});
			return config;
		}
	}
	// EO updateOpeningHours



	/**
	 * Parse a date string into date object
	 * Main support for date-picker, but also suited
	 * for all date inputs from desktop browsers and
	 * inputs from mobile browser with input type date.
	 *
	 * Dektop: 'D.M.YYYY'
	 * Mobile: 'YYYY-M-D'
	 *
	 * @method parseDay
	 * @param {String} daystr - date string in compatible form
	 * @param {Boolean} strict - disable overflow (default true)
	 * @returns {Date} date object (zero time) or null/false
	 */
	function parseDateDay(daystr, strict) {

		var fragments;
		// use object prototype to check if we have already a real date object
		if (Object.prototype.toString.call(daystr) === '[object Date]') { return daystr; }
		// defaults to true if argument is omitted
		if (arguments.length < 2) { strict = true; }
		// base validate assertion
		if (!daystr) { return null; }
		// match default desktop format: `D.M.YYYY`
		else if (daystr.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
			fragments = daystr.split('.');
		}
		// match default mobile format: `YYYY-M-D`
		else if (daystr.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/)) {
			fragments = daystr.split('-').reverse();
		}
		// incompatible format?
		if (!fragments) { return null; }
		// convert each part to integer
		var day = parseInt(fragments[0], 10),
			month = parseInt(fragments[1], 10),
			year = parseInt(fragments[2], 10);
		// create date object (some parts could overflow)
		var date = new Date(year, month - 1, day);
		// adjust for local timezone (if it was utc)
		// var tzoff = date.getTimezoneOffset() * 60;
		// date.setTime(date.getTime() - tzoff * 1000);

		// is overflow is allowed?
		if (!strict) { return date; }
		// check if no overflow occurred
		return (date.getDate() === day) &&
			(date.getFullYear() === year) &&
			(date.getMonth() + 1 === month) &&
			date; // returns date if all true
	}

	/**
	 * compare two dates if the are on the same day
	 * can be used to sort arrays of date objects
	 *
	 * @method compareDays
	 * @param {Date} a - first date object to compare
	 * @param {Date} b - second date object to compare
	 * @returns {int} 0 for same day, -1 if a < b, 1 if b > a;
	 */
	function compareDays(a, b) {
		// check if date are the same days
		if (a.getFullYear() === b.getFullYear() &&
			a.getMonth() === b.getMonth() &&
			a.getDate() === b.getDate()
		) {
			return 0;
		}
		// or compare dates
		return a < b ? -1 : 1;
	}

	/**
	 * get opening hours for specific day
	 * returns false if the day is closed
	 * but may also return an empty array
	 *
	 * @method getOpeningHours
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @returns {Array} list of opening blocks
	 */
	function getOpeningHours(date, config) {
		/* jslint maxdepth: 4 */
		// create on demand
		if (!config.day) {
			config.day = {};
		}
		// dereferenced variable access
		var oDay = config.day,
			oWeek = config.week,
			oHours = config.hours,
			oSpecial = config.special;
		// relevant date parts
		var day = date.getDate(),
			month = date.getMonth(),
			year = date.getFullYear();
		// inflate special days and add to normal day
		// we need to do this once for every year we see
		// use a flag to indicate which years are done
		if (oSpecial && !oSpecial[year]) {
			oSpecial[year] = true;
			for (var sday in oSpecial) {
				if (oSpecial.hasOwnProperty(sday)) {
					if (sday.match(/^easter([\+\-]\d+)?/)) {
						// get the easter date for the given year
						var edate = easterDate(date.getFullYear());
						// add optional offset to easter date (days)
						edate.setDate(edate.getDate() + parseInt(RegExp.$1 || 0, 10));
						// create the key for the working hours day (oDay) settings
						var ekey = [edate.getDate(), edate.getMonth() + 1, year].join('.');
						// attach easter config to day config now
						oDay[ekey] = oSpecial[sday];
					}
				}
			}
		}
		// create keys for day exception
		var mDay = day + '.' + (month + 1);
		var yDay = mDay + '.' + year;
		// check if date is a special year day
		// check if we have settings for day of year
		var yDayHours = oDay ? oDay[ yDay ] : undefined;
		if (yDayHours !== undefined) { return yDayHours; }
		// check if we have settings for day of month
		var mDayHours = oDay ? oDay[ mDay ] : undefined;
		if (mDayHours !== undefined) { return mDayHours; }
		// check if we have settings for day of week
		var wDayHours = oWeek ? oWeek[ date.getDay() ] : undefined;
		// if the value is true we want to let it "bubble" through
		if (wDayHours !== undefined && wDayHours !== true) { return wDayHours; }
		// fallback to the general opening hours
		return oHours || !config.time && [ 8, 17 ];
	}

	/**
	 * Get date of easter the given year
	 * ToDo: need to check for source attribution
	 * ToDo: might be hard to find out real origin
	 * ToDo: seems to be out in the wild for a while
	 * http://www.irt.org/articles/js052/index.htm
	 * http://stackoverflow.com/questions/1284314/easter-date-in-javascript
	 * http://coderzone.org/library/Get-Easter-Date-for-any-year-in-Javascript_1059.htm
	 *
	 * @method easterDate
	 * @param {int} year - full year (ie 2015)
	 * @returns {Date} easter date (with UTC time 12:00)
	 */
	function easterDate(Y) {
		var C = Math.floor(Y/100);
		var N = Y - 19*Math.floor(Y/19);
		var K = Math.floor((C - 17)/25);
		var I = C - Math.floor(C/4) - Math.floor((C - K)/3) + 19*N + 15;
		I = I - 30*Math.floor((I/30));
		I = I - Math.floor(I/28)*(1 - Math.floor(I/28)*Math.floor(29/(I + 1))*Math.floor((21 - N)/11));
		var J = Y + Math.floor(Y/4) + I + 2 - C + Math.floor(C/4);
		J = J - 7*Math.floor(J/7);
		var L = I - J;
		var M = 3 + Math.floor((L + 40)/44);
		var D = L + 28 - 31*Math.floor(M/4);
		return new Date(Date.UTC(Y, M - 1, D, 12));
	}

	/**
	 * Get minimum date given by constraints
	 *
	 * @method getMinDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} min date for the given constraint
	 */
	function getMinDate(date, config) {
		// relative date from config
		var minDate = config.minDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (minDate === -1) { minDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(minDate) !== '[object Date]') {
			if (minDate !== null && typeof minDate !== 'undefined') {
				minDate = addWorkDays(date, config, minDate || 0);
			}
		}
		// handle waiting period
		if (config.wPeriod) {
			// wait period is applied to either minDate or date
			// we never allow any past dates if the option is set
			minDate = nextAvailableDate(minDate || date, config);
		}
		// return if date is false or time preserved
		if (!minDate || config.time) { return minDate; }
		// reset date to first possible time of day
		return resetTime(minDate);
	}

	/**
	 * Get maximum date given by constraints
	 *
	 * @method getMaxDate
	 * @param {Date} date - date object (time is used)
	 * @param {Object} config - date constraint data
	 * @returns {Date} max date for the given constraint
	 */
	function getMaxDate(date, config) {
		// relative date from config
		var maxDate = config.maxDate;
		// normalize invalid passed argument
		// this needs to be fixed in some jsp
		if (maxDate === -1) { maxDate = null; }
		// we either accept a date object or an offset from current date
		if (Object.prototype.toString.call(maxDate) !== '[object Date]') {
			if (maxDate !== null && typeof maxDate !== 'undefined') {
				maxDate = addWorkDays(date, config, maxDate || 0);
			}
		}
		// return if date is false or time preserved
		if (!maxDate || config.time) { return maxDate; }
		// reset date to last possible time of day
		return endOfDay(maxDate);
	}

	/**
	 * Check if date is in range constraint
	 * Tests for `minDate` and `maxDate`
	 * Both ends are optional, so if nothing
	 * is given on config, always return true.
	 *
	 * @method isInDayRange
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - uses `minDate` and `maxDate`
	 * @returns {Boolean} true if between minDate and maxDate
	 */
	function isInDayRange(date, config) {

		// optional argument from config
		// mostly used for unit testing
		var now = config.now || new Date();

		// absolute or relative min/max dates
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);
		// finally check the min/max constraints
		return (!minDate || date >= minDate) && (!maxDate || date <= maxDate);
	}

	/**
	 * Check if given date is a work day
	 * Meaning we have some opening hours
	 *
	 * @method isWorkDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if it open that day
	 */
	function isWorkDay(date, config) {
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// compatibility for old option
		if (config.dateNoWeekends) {
			var dayOfWeek = date.getDay();
			if (dayOfWeek === 0) { return false; } // sun
			if (dayOfWeek === 6) { return false; } // sat
		}
		// check if day has opening hours (returns them)
		return hours && hours.length > 0 ? hours : false;
	}

	/**
	 * Check if given day is a valid day
	 * Meaning we have some opening hours
	 * And we can still book appointments
	 * Basically this returns true only if
	 * there is at least one valid date for
	 * that day (determined by isValidDate).
	 *
	 * @method isValidDay
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if day has valid times
	 */
	function isValidDay(date, config) {
		// get opening hours via work day check
		var hours = isWorkDay(date, config);
		// return early if no workday
		if (!hours) { return false; }
		// no time checks if option not set
		// if (!config.time) { return hours; }
		// make sure we have a valid time
		var now = config.now || new Date();
		// check further constraints for current day
		// we may have some min date constraints, which
		// means we need to check if minDate can have
		// some time which satisfies the constraints.
		var minDate = getMinDate(now, config),
			maxDate = getMaxDate(now, config);

		// we may not have a min date constraint
		if (!minDate) { minDate = new Date('Jan 1 1900 00:00:00'); }
		if (!maxDate) { maxDate = new Date('Jan 1 2900 23:59:59'); }

		if (config.maxDate >= 0 && !config.time) {
			maxDate = endOfDay(maxDate);
		}
		// compare days of min date and date to test
		var cmpMinDays = compareDays(date, minDate),
			cmpMaxDays = compareDays(date, maxDate);
		// check min date constraint
		if (cmpMinDays === 0) {
			// get time of date to be checked
			var time = toHours(minDate);
			// get last possible valid time (closing)
			var closing = hours[hours.length-1];
			// normaly we exclude closing time
			if (!config.includeClosingTime) {
				if (time === closing) { return false; }
				closing -= config.interval || 0;
			}
			// store may already be closed up
			if (closing < time) { return false; }
		}
		// obey date range conditions
		if (cmpMinDays < 0) {
			return false;
		}
		if (cmpMaxDays > 0) {
			return false;
		}
		// must be upcoming work day
		return hours;
	}

	/**
	 * Check if given date and time are valid
	 * Constraints can be simple min/max or more
	 * complex checkings as for a valid appointment
	 * within opening hours (with a waiting period)
	 *
	 * @method isValidDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - constraint data
	 * @returns {Boolean} true if date is valid
	 */
	function isValidDate(date, config) {
		// run cheapest tests (workday and range check)
		// if (!isWorkDay(date, config)) { return false; }
		if (!isValidDay(date, config)) { return false; }
		if (!isInDayRange(date, config)) { return false; }
		// get opening hours for day from config
		var hours = getOpeningHours(date, config);
		// with disabled time a simple `isWorkDay`check is enough
		if (!config.time) { return hours && hours.length > 0; }
		// then check if the time is insisde opening hours
		var time = toHours(date);
		// check all opening hour blocks
		for (var n = 0; n < hours.length; n += 2) {
			// just to be sure we do good math
			// could be disabled for performance
			var opening = Math.min(hours[n+0], hours[n+1]),
				closing = Math.max(hours[n+1], hours[n+0]);
			// return success if time was found to be open
			// the closing time itself is not valid
			if (opening <= time && time <= closing) {
				// obey special option to include closing time (inline check)
				if (!config.includeClosingTime && time === closing) { return false; }
				// optionally check if time obeys interval
				var interval = (config.interval || 0);
				return !interval || (time - opening) % interval === 0;
			}
		}
		// store closed
		return false;
	}

	/**
	 * Convert date object, string ('11:30', '9.5') or number (9.5)
	 * to floating number representing the time denominated in hours
	 *
	 * @method toHours
	 * @param {Date|string} date - input
	 * @returns {float} time in hours (0-24+)
	 */
	function toHours(date) {
		// use object prototype to reveal sepecific type
		var type = Object.prototype.toString.call(date);
		// convert from date object
		if (type === '[object Date]') {
			return date.getHours() +
				date.getMinutes() / 60 +
				date.getSeconds() / 3600 +
				date.getMilliseconds() / 360000;
		}
		// convert from a string (ie '11:30')
		// all parts optional and can be floats
		else if (type === '[object String]') {
			var part = date.split(':');
			return parseFloat(part[0] || 0, 10) +
				parseFloat(part[1] || 0, 10) / 60 +
				parseFloat(part[2] || 0, 10) / 3600;
		}
		// otherwise try to convert to float
		else { return parseFloat(date || 0, 10); }
	}

	/**
	 * Add days to a date object (return copy)
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addDays(date, offset) {
		var cpy = new Date(date);
		cpy.setDate(cpy.getDate() + offset);
		return cpy;
	}

	/**
	 * Add work days to date object (return copy)
	 * Holidays are not counted when skipped
	 * This also works for negative offsets
	 *
	 * @method addDays
	 * @param {Date} date - input date to be offset
	 * @param {Date} offset - number of days to offset
	 * @returns {Date} date plus offset (might be negative)
	 */
	function addWorkDays(date, config, offset) {
		var cpy = new Date(date);
		var sign = offset < 0 ? -1 : 1;
		var wDays = Math.round(Math.abs(offset));
		// using `-1` is same as `0` but instead
		// of going forward, it goes backwards
		if (sign < 0) {
			wDays -= 1;
		}
		// loop with abort condition
		while (true) {
			// just skip over any holidays
			while (!isWorkDay(cpy, config)) {
				cpy.setDate(cpy.getDate() + sign);
			}
			// have a workday now
			// decrease days to go
				wDays -= 1;
			// check abort condition
			if (wDays <= -0.5) {
				break;
			}
			// move the date iteration object
			cpy.setDate(cpy.getDate() + sign);
		}
		return cpy;
	}

	/**
	 * Calculate next available appointment from date
	 * Employees may need time to prepare appointment
	 * Waiting Period can also be set directly on config
	 *
	 * @method nextAvailableDate
	 * @param {Date} date - date object (time not used)
	 * @param {Object} config - business hours settings
	 * @param {int} wPeriod - waiting period (hours)
	 * @returns {Date} next available appointment
	 */
	function nextAvailableDate(date, config, wPeriod) {

		/* jslint maxdepth: 5 */

		// get a new date object copy
		// also main return object
		var slot = new Date(date);

		// ensure valid number from optional arg or config
		wPeriod = parseFloat(wPeriod || config.wPeriod || 0, 10);

		// need fine grained loop control
		// easier to handle edge cases
		while (true) {
			// get opening hour blocks for the slot day
			var hours = getOpeningHours(slot, config);

			// get hours from date object as float
			var start = toHours(slot);

			// don't need the time part anymore on slot
			// re-calculated from wPeriod and work blocks
			// we just increment the day in the loop below
			slot = resetTime(slot);

			// are there some opening hours?
			if (hours && hours.length > 0) {

				// increment for next available timeslot
				// during the loop we deduct from wPeriod
				for (var n = 0; n < hours.length; n += 2) {

					// just to be sure we do good math
					// could be disabled for performance
					var opening = Math.min(hours[n+0], hours[n+1]),
						closing = Math.max(hours[n+1], hours[n+0]);

					// store is not closed
					if (start <= closing) {
						// start is before opening
						if (start < opening) {
							// move start to opening
							start = opening;
						}
						// deduct time spent in block
						wPeriod -= closing - start;
						// check stop condition
						if (wPeriod <= 0) {
							// calculate final time
							var time = closing + wPeriod;
							// set the time for the slot
							slot.setSeconds(time * 3600 + 0.5);
							// return date object
							return slot;
						}

					}
					// EO if not closed

				}
				// EO for hours loop

			}
			// EO if opening hours

			// move date slot to the next day
			slot.setDate(slot.getDate() + 1);
			start = 0; // reset start time

		}
		// EO while true

		// return date object
		return slot;

	}
	// EO nextAvailableDate

	SCS.utils.date = {
		fromString: fromString,
		format: format,
		resetTime: resetTime,
		endOfDay: endOfDay,
		formatDailyHours: formatDailyHours,
		parseOpeningHours: parseOpeningHours,
		updateOpeningHours: updateOpeningHours,
		parseDateDay: parseDateDay,
		compareDays: compareDays,
		getOpeningHours: getOpeningHours,
		easterDate: easterDate,
		getMinDate: getMinDate,
		getMaxDate: getMaxDate,
		isInDayRange: isInDayRange,
		isWorkDay: isWorkDay,
		isValidDay: isValidDay,
		isValidDate: isValidDate,
		toHours: toHours,
		addDays: addDays,
		addWorkDays: addWorkDays,
		nextAvailableDate: nextAvailableDate
	};
	// EO SCS.utils.date

	/**
	 * Compares two version strings of the format '1.8.3'
	 *
	 * Returns
	 * -1	if the first string is newer/higher
	 *	0	if the strings are equal
	 *	1	if the second string is newer/higher
	 *
	 * @param versionStringOne
	 * @param versionStringTwo
	 * @returns {number}
	 */
	SCS.utils.compareVersions = function(versionStringOne, versionStringTwo) {
		var versionValuesOne = SCS.utils.getVersionNumberArray(versionStringOne),
			versionValuesTwo = SCS.utils.getVersionNumberArray(versionStringTwo),
			maxValuesToCompare = Math.min(versionValuesOne.length, versionValuesTwo.length),
			compareStatus = 0;

		for(var i = 0; i < maxValuesToCompare && compareStatus === 0; i += 1){
			if(versionValuesOne[i] > versionValuesTwo[i]) {
				compareStatus = -1;
			}
			else if(versionValuesOne[i] < versionValuesTwo[i]) {
				compareStatus = 1;
			}
		}

		return compareStatus;
	};

	/**
	 * Turns a version string of format '1.2.3' into an array of int values
	 * @param versionString
	 * @returns {Array}
	 */
	SCS.utils.getVersionNumberArray = function(versionString) {
		var versionValues = versionString && versionString.split('.') || [];
		for(var i = 0; i < versionValues.length; i += 1){
			versionValues[i] = parseInt(versionValues[i], 10);
		}

		return versionValues;
	};

	// FIXME: Remove once unused
	SCS.utils.formatString = require('lib/util/string').format;

	/**
	 * Frontend caching system functions
	 *
	 * @namespace SCS.utils.cache
	 */
	SCS.utils.cache =  {
		/**
		 * This function caches given data to the browser localstorage and adds the
		 * timestamp that indicates untill the cached data are valid.
		 *
		 * @method cacheData
		 * @memberof SCS.utils.cache
		 * @param {JSON} data Data to be cached
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @param {Number} validCachePeriod Time in milliseconds that indicates how
		 * long the cached data is considered to be valid.
		 * @returns void
		 */
		cacheData: function (data, dataId, validCachePeriod) {
			var storeData = {
				data: data,
				expireTime: (new Date()).getTime() + (validCachePeriod || 0)
			};
			localStorage.setItem(dataId, JSON.stringify(storeData));
		},
		/**
		 * This function returns cached data for the given key value. If data does
		 * not exists or cache timestamp is expired this function returns null.
		 *
		 * @method getCacheData
		 * @memberof SCS.utils.cache
		 * @param {String} dataId localstorage key under which the given data are
		 * stored
		 * @returns Cached data or null
		 */
		getCacheData: function (dataId) {
			var cachedData = localStorage.getItem(dataId);
			if(cachedData) {
				cachedData = JSON.parse(cachedData);
				if(cachedData.expireTime && (cachedData.expireTime - (new Date()).getTime()) >= 0) {
					return cachedData.data;
				} else {
					localStorage.removeItem(dataId);
				}
			}
			return null;
		}
	};
}(window.$ || window.Tc.$, window.SCS = window.SCS || {}));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.utils.js
// module id = 34
// module chunks = 0